import { useState } from 'react'

import { ReactComponent as IconPacemaker } from '@/assets/images/icons/icon-pacemaker.svg'
import { ReactComponent as IconVolunteer } from '@/assets/images/icons/icon-volonteer.svg'

import Modal from '@/components/Modals/Modal/Modal'

import styles from './JoinTeam.module.scss'

function JoinTeam() {
  const [isOpenVolunteerModal, setIsOpenVolunteerModal] = useState(false)
  const [isOpenPacemakerModal, setIsOpenPacemakerModal] = useState(false)

  return (
    <section className={styles.joinTeam}>
      <div className={styles.inner}>
        <h2 className={styles.title}>Присоединяйся к команде!</h2>
        <p className={styles.desc}>
          Стань частью Всероссийского полумарафона с синхронным стартом в своём городе в составе команды крупнейшего
          спортивного организатора.
        </p>

        <div className={styles.cards}>
          <div className={styles.cardWrap}>
            <div
              className={styles.card}
              onClick={() => setIsOpenVolunteerModal(true)}
              style={{ cursor: 'pointer' }}
            >
              <IconVolunteer className={`${styles.icon} ${styles.iconVolunteer}`} />
              <p className={styles.label}>Хочу быть волонтёром</p>
            </div>

            <button className={styles.button} onClick={() => setIsOpenVolunteerModal(true)}>
              Кто такой волонтер?
            </button>
          </div>

          <div className={styles.cardWrap}>
            <div
              className={styles.card}
              onClick={() => setIsOpenPacemakerModal(true)}
              style={{ cursor: 'pointer' }}
            >
              <IconPacemaker className={`${styles.icon} ${styles.iconPacemaker}`} />
              <p className={styles.label}>Хочу стать пейсмейкером</p>
            </div>

            <button className={styles.button} onClick={() => setIsOpenPacemakerModal(true)}>
              Кто такой пейсмейкер?
            </button>
          </div>
        </div>
      </div>

      <Modal isOpen={isOpenVolunteerModal} onClose={() => setIsOpenVolunteerModal(false)}>
        <div className={styles.modalInner}>
          <p className={styles.modalTitle}>кто такой волонтёр?</p>

          <p className={styles.modalText}>
            Волонтёры — это добровольцы, которые помогают участникам забега и болельщикам.
          </p>

          <p className={styles.modalText}>
            Если тебе хочется быть причастным к здоровому и спортивному сообществу и не терпится поделиться своим
            позитивом с другими людьми — оставляй заявку!
          </p>

          <a className={styles.modalLink} href="https://forms.gle/SK7kpTSmrwnh9y1y9">
            Оставить заявку
          </a>
        </div>
      </Modal>

      <Modal isOpen={isOpenPacemakerModal} onClose={() => setIsOpenPacemakerModal(false)}>
        <div className={`${styles.modalInner} ${styles.pacemakerModalInner}`}>
          <p className={styles.modalTitle}>Кто такой пейсмейкер?</p>

          <p className={styles.modalText}>
            Пейсмейкеры — это бегуны, которые проходят всю дистанцию в определённом темпе и помогают другим участникам:
          </p>

          <ul className={styles.modalList}>
            <li>финишировать с нужным результатом,</li>
            <li>правильно распределять силы на забеге,</li>
            <li>обрести компанию,</li>
            <li>ориентироваться на темп без гаджетов,</li>
            <li>предупреждают о сложных участках и ближайших пунктах питания.</li>
          </ul>

          <p className={styles.modalText}>
            На ЗаБег.РФ ты сможешь встретить пейсмейкеров на дистанциях 10 км и 21.1 км.
          </p>

          <a className={styles.modalLink} href="https://docs.google.com/forms/d/e/1FAIpQLSdzxMaQlbD_vShg1eCAX4DqtAvDiIM5gQGhJ6j3lDx1L86Znw/viewform">
            хочу быть пейсмейкером
          </a>
        </div>
      </Modal>
    </section>
  )
}

export default JoinTeam
